"use client"

import React, {useEffect, useRef, useState} from "react";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {useGSAP} from "@gsap/react";
import {CiCompass1, CiImport as ImportIcon} from "react-icons/ci";
import {FaCheckCircle as SelectIcon, FaInstagramSquare, FaShareAlt as PostIcon} from "react-icons/fa";
import {HiTemplate as ChooseTemplateIcon} from "react-icons/hi";
import {MdDashboardCustomize as CustomizeItIcon} from "react-icons/md";
import "./content.css"


gsap.registerPlugin(ScrollTrigger);
gsap.defaults({overwrite: 'auto'});

function Head(props) {
    const {marker, icon: Icon, iconClass, title, description} = props

    return (
        <div className="contentMarker" style={{height: 470, width: 200, display: "flex", justifyContent: "flex-end"}}
             data-marker-content={marker}>
            <h3 style={{top: "50%", position: "relative"}}>{title}</h3>
        </div>)
}

function getComponentFromString(componentString) {
    const componentMap = {
        '<ImportIcon/>': <ImportIcon />,
        '<SelectIcon/>': <SelectIcon />,
        '<ChooseTemplateIcon/>': <ChooseTemplateIcon />,
        '<CustomizeItIcon/>': <CustomizeItIcon />,
        '<PostIcon/>': <PostIcon />,
    };

    return componentMap[componentString] || null;
}

function Card(props) {
    const {marker, icon: Icon, iconClass, title, description} = props

    return (<div className="features-card-item features-card-item-fixed contentMarker"
                 data-marker-content={marker}>
        <div className={`icon ${iconClass}`}>
            {getComponentFromString(Icon)}
        </div>
        <h3>{title}</h3>
        <p>{description}
        </p>
    </div>)

}

export default function WrapsodyGsapScroll({data}) {

    const {scrollComponent} = data
    const container = React.useRef();

    React.useEffect(() => {
        const handleResize = () => {
            gsap.set(".left-content > *", {xPercent: -50, yPercent: window.innerWidth > 1200 ? -45 : 5});
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            gsap.set(".left-content > *", {xPercent: -50, yPercent: window.innerWidth > 1200 ? -45 : 5});
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    function handleGSAP() {
        const contentMarkers = gsap.utils.toArray(".contentMarker");

        // Set up our scroll trigger
        const ST = ScrollTrigger.create({
            trigger: ".content-container",
            start: "top top",
            end: "bottom 80%",
            onUpdate: getCurrentSection,
            scrub: 1,
            pin: ".left-content",
            //markers: {startColor: "green", endColor: "blue", fontSize: "18px", fontWeight: "bold", indent: 20},
            invalidateOnRefresh: true
        });


        // Set up our content behaviors
        contentMarkers && contentMarkers.forEach(marker => {
            marker.content = document.querySelector(`#${marker.dataset.markerContent}`);
            //console.log(`Entering ${marker.content?.id} with ${marker.content.tagName}`)
            if (marker.content.tagName === "IMG") {
                gsap.set(marker.content, {transformOrigin: "center"});

                marker.content.enter = function () {
                    console.log(`Executing enter for ${marker.content.id}`)
                    gsap.fromTo(marker.content, {autoAlpha: 0, rotateY: -30}, {
                        duration: 0.3,
                        autoAlpha: 1,
                        rotateY: 0
                    });
                }
            }

            marker.content.leave = function () {
                gsap.to(marker.content, {duration: 0.1, autoAlpha: 0});
            }

        });

        // Handle the updated position
        let lastContent;


        function getCurrentSection(trigger) {
            let newContent;
            const currScroll = scrollY;

            // Find the current section
            contentMarkers && contentMarkers.forEach(marker => {
                if (currScroll > (marker.offsetTop + trigger.start)) {
                    newContent = marker.content;
                }
            });


            // If the current section is different then that last, animate in
            if (newContent
                && (lastContent == null
                    || !newContent.isSameNode(lastContent))) {
                // Fade out last section
                if (lastContent) {
                    console.log(`Leaving ${lastContent.id}`)
                    lastContent.leave();
                }

                // Animate in new section
                //console.log(`Entering ${newContent.id}`)
                newContent.enter();

                lastContent = newContent;
            }

        }

        const media = window.matchMedia("screen and (max-width: 800px)");
        ScrollTrigger.addEventListener("refreshInit", checkSTState);
        checkSTState();

        function checkSTState() {
            if (media.matches) {
                ST.disable();
            } else {
                ST.enable();
            }
        }
    }

    useGSAP(
        () => {
            handleGSAP();
        },
        //{scope: container}
    );

    return (
        <div className="content-container" ref={container}>
            {/*<div class="right-content">
                <div className="container">
                    {appStagesData.map(stage =>
                        <Head {...stage}/>
                    )}
                    <div style={{height: 475}}/>
                </div>
            </div>*/}
            <div className="left-content">
                {scrollComponent && scrollComponent.map((itm) => (
                    <img key={itm?.marker} id={itm?.marker} className="imageToShow" src={itm?.image?.url}
                         alt={itm?.altText}/>
                ))}
            </div>
            <div className="right-content">
                <section className="our-best-features-wrapper">
                    <div className="container">
                        {scrollComponent && scrollComponent.map((itm, index) =>
                            (
                                <Card
                                    key={`crd-${index}`}
                                    {...itm}
                                />
                            ))}
                        <div style={{height: 475}}/>
                    </div>
                </section>
            </div>
        </div>
    )
}
